import loadable from '@loadable/component';

export const OrgDashboardViewIntegrationPageLoadable = loadable(
  () => import('./OrgDashboardViewIntegrationPage'),
  { resolveComponent: (module) => module.OrgDashboardViewIntegrationPage },
);
